module.exports = __webpack_public_path__ + "static/media/desktop.e88b394f.svg";